var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 11C0.25 5.08579 5.08579 0.25 11 0.25C16.9142 0.25 21.75 5.08579 21.75 11C21.75 16.9142 16.9142 21.75 11 21.75C5.08579 21.75 0.25 16.9142 0.25 11ZM11 1.75C5.91421 1.75 1.75 5.91421 1.75 11C1.75 16.0858 5.91421 20.25 11 20.25C16.0858 20.25 20.25 16.0858 20.25 11C20.25 5.91421 16.0858 1.75 11 1.75ZM6.25 11C6.25 10.5858 6.58579 10.25 7 10.25H10.25V7C10.25 6.58579 10.5858 6.25 11 6.25C11.4142 6.25 11.75 6.58579 11.75 7V10.25H15C15.4142 10.25 15.75 10.5858 15.75 11C15.75 11.4142 15.4142 11.75 15 11.75H11.75V15C11.75 15.4142 11.4142 15.75 11 15.75C10.5858 15.75 10.25 15.4142 10.25 15V11.75H7C6.58579 11.75 6.25 11.4142 6.25 11Z",
    fill: "#003F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAdd);
export default __webpack_public_path__ + "static/media/ico-add.1839d22838d36d8dc3eae3369aa1dad2.svg";
export { ForwardRef as ReactComponent };